import { makeUrlStateContext } from '@percept/hooks'
import { SponsorshipsState } from './typings'

export const SponsorshipsStateContext = makeUrlStateContext<SponsorshipsState>()
